import { loadBreadCrum } from "../../utils/localStorage";
export const initialState = loadBreadCrum() || {
  breadCrumbText: "",
  breadCrumbSubText: "",
  index: 0,
  isSubmit: false,
  path: "",
  subPath: "",
  open: false,
  isButtonCreate: false,
  isSaveStartProcess: false,
  isCancelStartProcess: false,
  isCreateReqStartProcess: false,
  isEditCv: false,
  isCreateCv: false,
  isUserConfig: false,
  handleCancelCv: false,
  handleCreateCv: false,
  handleEditCv: false,
  submitContract: false,
  handleCancelUserConfig: false,
  handleSaveUserConfig: false,
  handleSaveOrderClauses: false,
  pathContarct: "",
  isSavePermission: false,
  isMedicalExam: false,
  isSubmitOrderExam: false,
  handleOpenForm: false,
  handleCreatePermission: false,
  isCollectiveService: false,
};

const breadCrumbsReducer = (state = initialState, action) => {
  if (action.type === "SET_BREADCRUMB") {
    const saveBreadCrum = JSON.stringify({
      ...state,
      breadCrumbText: action.breadCrumbText,
      path: action.path,
      subPath: action.subPath,
      isSubmit: action.isSubmit,
      breadCrumbSubText: action.breadCrumbSubText,
      open: action.open,
      isButtonCreate: action.isButtonCreate,
      index: action.index,
      isSaveStartProcess: action.isSaveStartProcess,
      isCancelStartProcess: action.isCancelStartProcess,
      isCreateReqStartProcess: action.isCreateReqStartProcess,
      isEditCv: action.isEditCv,
      isCreateCv: action.isCreateCv,
      handleCancelCv: action.handleCancelCv,
      handleCreateCv: action.handleCreateCv,
      handleEditCv: action.handleEditCv,
      submitContract: action.submitContract,
      handleCancelUserConfig: action.handleCancelUserConfig,
      handleSaveUserConfig: action.handleSaveUserConfig,
      isUserConfig: action.isUserConfig,
      handleSaveOrderClauses: action.handleSaveOrderClauses,
      pathContarct: action.pathContarct,
      isSavePermission: action.isSavePermission,
      isMedicalExam: action.isMedicalExam,
      isSubmitOrderExam: action.isSubmitOrderExam,
      handleOpenForm: action.handleOpenForm,
      handleCreatePermission: action.handleCreatePermission,
      isCollectiveService: action.isCollectiveService
    });
    localStorage.setItem("breadCrum", saveBreadCrum);
  }

  switch (action.type) {
    case "SET_BREADCRUMB":
      return {
        ...state,
        breadCrumbText: action.breadCrumbText,
        path: action.path,
        subPath: action.subPath,
        isSubmit: action.isSubmit,
        open: action.open,
        breadCrumbSubText: action.breadCrumbSubText,
        isButtonCreate: action.isButtonCreate,
        index: action.index,
        isSaveStartProcess: action.isSaveStartProcess,
        isCancelStartProcess: action.isCancelStartProcess,
        isCreateReqStartProcess: action.isCreateReqStartProcess,
        isEditCv: action.isEditCv,
        isCreateCv: action.isCreateCv,
        handleCancelCv: action.handleCancelCv,
        handleCreateCv: action.handleCreateCv,
        handleEditCv: action.handleEditCv,
        submitContract: action.submitContract,
        handleCancelUserConfig: action.handleCancelUserConfig,
        handleSaveUserConfig: action.handleSaveUserConfig,
        isUserConfig: action.isUserConfig,
        handleSaveOrderClauses: action.handleSaveOrderClauses,
        pathContarct: action.pathContarct,
        isSavePermission: action.isSavePermission,
        isMedicalExam: action.isMedicalExam,
        isSubmitOrderExam: action.isSubmitOrderExam,
        handleOpenForm: action.handleOpenForm,
        handleCreatePermission: action.handleCreatePermission,
        isCollectiveService: action.isCollectiveService
      };
    default:
      return state;
  }
};

export default breadCrumbsReducer;
